module.exports = __webpack_public_path__ + "img/icon_5_19.dd00f16d.png";